<template>
  <div class="scroll-lyrics" :style="theStyle">
    <div class="mark"></div>
    <lee-slide theme="green" @touchstart="press=true" @touchend="press=false,media.currentTime = (progress / 100) * mduration" @mousedown="press=true" @mouseup="press=false,media.currentTime = (progress / 100) * mduration"
               v-model="progress" style="position: absolute;width: 100%;bottom: 0;z-index: 1"></lee-slide>
    <lee-button type="default" v-if="!playStatus" @click="bf">播放</lee-button>
    <lee-button type="leecolor" v-else @click="zt">停止</lee-button>
    <div class="bgcolor" v-if="!bgPic" :style="'--bgcolor:'+bgColor"></div>
    <div class="bgpic" v-else :style="'--bgpic:url('+bgPic+')'"></div>
    <div class="lyrics" :style="'--color:'+color+';--activeColor:'+activeColor+';--lineHeight:'+lineHeight+'px'">
      <ul :style="'transform:translateY('+scrollY+'px)'">
        <li v-for="(item,xh) in text" :key="xh" :class="{cur:item.cur}">{{item.text}}</li>
      </ul>
    </div>
    <audio :src="audio" style="display: none;" ref="media"></audio>
  </div>
</template>
<script>

export default {
    name: 'LeeScrollLyrics',
    inheritAttrs: false,
    data() {
        return {
            progress: 0,
            text: [],//歌词列表
            playStatus: false,//播放状态
            media: null,//声音DOM
            set: null,//定时器
            scrollY: 0,
            mcurtime: 0,
            mduration: 1,
            press: false,//進度條是否按下去
        }
    },
    watch: {
        playStatus: {
            immediate: true,
            handler(value) {
                if (value) {
                    this.set = setInterval(() => {
                        this.action()
                    }, 1)
                } else {
                    clearInterval(this.set)
                }
            }
        },
        press: {
            immediate: true,
            handler(value) {
                if (value) {
                    clearInterval(this.set)
                } else {
                    if (this.playStatus) {
                        this.set = setInterval(() => {
                            this.action()
                        }, 1)
                    } else {
                        if (this.mcurtime != 0) {
                            this.playStatus = true
                            this.media.play()
                        }
                    }
                }
            }
        },
    },
    computed: {
        theStyle() {
            let ww, hh
            if (this.width === 'fit') {
                ww = '100%'
            } else {
                ww = this.width + 'px'

            }
            if (this.height === 'fit') {
                hh = '100%'
            } else {
                hh = this.height + 'px'
            }

            return 'width:' + ww + ';height:' + hh + ';--activeColor:' + this.activeColor
        }
    },
    mounted() {
        this.media = this.$refs.media
        let _this = this
        fetch(this.lyrics)
            .then(function (response) {
                return response.text();
            })
            .then(function (myJson) {
                let line = myJson.split('\n');
                line.forEach((el, xh) => {
                    let rs = el.split(']');
                    if (rs[1] == undefined) {
                        rs[1] = "";
                    }
                    _this.text.push({xh: xh + 1, time: rs[0] + ']', text: rs[1]});
                })

            });
        //这个是为了滑动条释放
        document.addEventListener('mouseup', () => {
            if(this.mcurtime!=(this.progress / 100) * this.mduration){
                this.press=false
                this.media.currentTime = (this.progress / 100) * this.mduration//是为了防止没有拖动滑块
            }
        })
    },
    methods: {
        action() {
            this.mcurtime = this.media.currentTime
            this.mduration = this.media.duration
            this.progress = (this.mcurtime / this.mduration) * 100
            this.text.forEach((el) => {
                this.$set(el, 'cur', false)
            })
            let fi = this.text.filter((el) => {
                let min = Number(el.time.substr(1, 2));
                let sec = Number(el.time.substring(4, el.time.length - 1));
                let lastSec = min * 60 + sec;
                let diff = this.media.currentTime;
                return diff - lastSec >= 0
            })
            this.$set(fi[fi.length - 1], 'cur', true)
            let midxh = this.height * 0.8 / this.lineHeight//这个是中间序号，这样滚动加亮在整体中间
            midxh = Math.floor(midxh / 2)
            if (fi[fi.length - 1].xh > midxh && this.scrollY < midxh * this.lineHeight) {
                this.scrollY = -this.lineHeight * (fi[fi.length - 1].xh - midxh);
            } else {
                this.scrollY = 0
            }
        },
        bf() {
            this.media.play()
            this.playStatus = true
        },
        zt() {
            this.media.pause()
            this.playStatus = false
        },
    },
    props: {
        width: [String, Number],
        height: [String, Number],
        audio: {
            type: String,
            default: '/scrolllyrics/lxl.mp3'
        },
        lyrics: {
            type: String,
            default: '/scrolllyrics/lxl.txt'
        },
        bgPic: {
            type: String,
            default: ''
        },
        bgColor: {
            type: String,
            default: '#46bd87'
        },
        color: {
            type: String,
            default: '#000'
        },
        activeColor: {
            type: String,
            default: '#46bd87'
        },
        lineHeight: {
            type: Number,
            default: 36
        },
    }
}
</script>
<style>
.scroll-lyrics {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
}

.scroll-lyrics .mark {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  background: linear-gradient(0deg, #000, rgba(0, 0, 0, .4), #000);
  z-index: 1;
}

.scroll-lyrics .progress {
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: 100%;
  height: 6px;
  background: #ddd;
  z-index: 4;
  display: flex;
}

.scroll-lyrics .progress span {
  height: 100%;
  width: 0;
  background: var(--activeColor);
}

.scroll-lyrics .bgcolor {
  background: var(--bgcolor);
}

.scroll-lyrics .bgpic {
  background-image: var(--bgpic);
  background-size: cover;
}

.scroll-lyrics .bgcolor, .scroll-lyrics .bgpic {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 0;
}

.scroll-lyrics .lyrics {
  width: 80%;
  height: 80%;
  overflow: hidden;
  z-index: 2;
  color: var(--color);
}

.scroll-lyrics .lyrics ul {
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: all .5s
}

.scroll-lyrics .lyrics ul li {
  line-height: var(--lineHeight);
  font-size: 16px;
  height: var(--lineHeight);
  transition: all .5s;
}

.scroll-lyrics .lyrics ul li.cur {
  color: var(--activeColor);
  transform: scale(1.5);
}

.scroll-lyrics .lee-button {
  position: absolute !important;
  z-index: 4;
  right: 15px;
  bottom: 15px;
}

[type="range"] {
  appearance: none;
  background: none !important;
}

[type="range"]::-webkit-slider-container {
  overflow: hidden;
}

[type="range"]::-webkit-slider-runnable-track {
  height: 6px;
  background: #ddd;
  /*可以修改轨道的若干样式*/
}

[type="range"]::-webkit-slider-thumb {
  position: relative;
  -webkit-appearance: none;
  appearance: none;
  width: 0px;
  height: 6px;
  border-radius: 50%;
  background-color: var(--activeColor);
  margin-top: -0px;
  border: 0px solid transparent;
  border-image: linear-gradient(var(--activeColor), var(--activeColor)) 0 fill;
  border-image-width: 0 0 0 0;
  border-image-outset: 0 0 0 99vw; /*绘制元素外矩形*/

}

</style>



// WEBPACK FOOTER //
// node_modules/leevueplugin/src/LeeScrollLyrics.vue